import { getNoteCategories, NoteCategoryDto } from '@dispatch/shared/services';
import { useQuery as useReactQuery } from 'react-query';

const FIVE_MINUTES = 5 * 60 * 1000;

/**
 * useNoteCategories - React Query wrapper for the tenant note-categories list.
 * Caches by (tenantId, includeRetired) and stays fresh for 5 minutes.
 */
export const useNoteCategories = (
  tenantId?: string,
  includeRetired = false
) => {
  return useReactQuery<NoteCategoryDto[]>(
    ['note-categories', tenantId, includeRetired],
    () => getNoteCategories(includeRetired),
    {
      enabled: !!tenantId,
      staleTime: FIVE_MINUTES,
    }
  );
};
